import { Pipe, PipeTransform } from '@angular/core';

/**
 * Calls a row-mapping function from a template without creating a new closure on
 * every change detection cycle (`row | renderFunction : column.renderFn`).
 */
@Pipe({
  name: 'renderFunction',
})
export class RenderFunctionPipe implements PipeTransform {
  transform<T, R>(row: T, renderFn?: (row: T) => R): R | undefined {
    return renderFn ? renderFn(row) : undefined;
  }
}
